import {
  Accordion,
  Box,
  Grid,
  Group,
  NumberInput,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import {
  IconBolt,
  IconCalendarTime,
  IconClock,
  IconGauge,
  IconRepeat,
  IconSettings,
  IconX,
} from "@tabler/icons-react";
import React, { useState } from "react";
import ProgramCard from "../../../newsletter/ProgramCard";
import { useLanguage } from "../../../../../stores/LanguageStore";
import dayjs from "dayjs";
import { useCampaignStore } from "../../../../../stores/CampaignStore";
import { DateTimePicker, TimeInput } from "@mantine/dates";
import NewsletterBlacklistsExclusion from "../../../newsletter/NewsletterBlacklistsExclusion";
import NewsletterSentCampaignExclusion from "../../../newsletter/NewsletterSentCampaignExclusion";
import NewsletterAdvancedSettings from "../../../newsletter/NewsletterAdvancedSettings";
import CampaignSummary from "./CampaignSummary";

const StepRecap = () => {
  const lang = useLanguage((s) => s.language);
  const timeStart = useCampaignStore((s) => s.timeStart);
  const setTimeStart = useCampaignStore((s) => s.setTimeStart);
  const programData = useCampaignStore((s) => s.programData);
  const setProgramData = useCampaignStore((s) => s.setProgramData);

  const [editDate, setEditDate] = useState(false);
  const [editTime, setEditTime] = useState(false);
  const [editLimit, setEditLimit] = useState(false);

  const dailyLimit = programData?.daily_send_limit || 0;
  const isAuto = programData?.send_to_future || false;

  const updateData = (field, value) => {
    setProgramData({
      ...programData,
      [field]: value,
    });
    // setProgramData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <Group wrap="nowrap">
      <Box mx="auto" p="xl" pos={"relative"} flex={1}>
        {/* HEADER */}
        <Stack gap={4} mb="xl">
          <Text c="violet.5" fw={600} size="md">
            Étape finale · Lancement
          </Text>
          <Text
            component="h1"
            size="xl"
            fw={700}
            m={0}
            style={{ fontSize: 24 }}
          >
            Programmez votre campagne
          </Text>
          <Text c="dimmed" size="sm">
            Ajustez les paramètres d’envoi pour votre aqent
          </Text>
        </Stack>

        <Accordion
          variant="contained"
          bg={"#fff"}
          radius={"xl"}
          // defaultValue={"list"}
          mt={"md"}
        >
          <Accordion.Item value="list">
            <Accordion.Control>
              <Group>
                <ThemeIcon
                  variant="light"
                  size={"xl"}
                  radius={"xl"}
                  color="primary"
                >
                  <IconClock />
                </ThemeIcon>
                <Stack gap={0}>
                  <Text fw={600}>Paramètres d’envoi</Text>
                  <Text c="dimmed" size="sm">
                    Envoyez maintenant ou programmez pour plus tard.
                  </Text>
                </Stack>
              </Group>
            </Accordion.Control>

            <Accordion.Panel>
              <Grid gutter="md" mt="sm">
                {/* 1. DATE DU PREMIER ENVOI */}
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <ProgramCard
                    icon={<IconBolt size={24} />}
                    label={
                      lang.workflows?.program?.step_config?.date_start ||
                      "Date du premier envoi"
                    }
                    valueDisplay={dayjs(
                      programData?.date_start
                        ? new Date(programData.date_start)
                        : new Date(),
                    ).format("DD MMM YYYY à HH:mm A")}
                    bg="var(--mantine-color-primary-0)"
                    isEditing={editDate}
                    setIsEditing={setEditDate}
                    editorComponent={
                      <DateTimePicker
                        onChange={(val) => {
                          updateData("date_start", val?.toISOString());
                        }}
                        value={
                          programData?.date_start
                            ? new Date(programData.date_start)
                            : new Date()
                        }
                        leftSection={<IconCalendarTime size={16} />}
                        valueFormat="DD MMM YYYY à HH:mm A"
                        size="sm"
                        radius="md"
                        w="100%"
                        autoFocus
                      />
                    }
                  />
                </Grid.Col>

                {/* 2. HEURE DE DÉBUT SCÉNARIO */}
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <ProgramCard
                    icon={<IconClock size={24} />}
                    label="Heure de début du scenario pour les jours suivants*"
                    valueDisplay={timeStart}
                    helpText={
                      lang.workflows.program.step_config.time_start_sending_help
                    }
                    rightBottom={
                      programData?.time_sending_timezone ||
                      Intl.DateTimeFormat().resolvedOptions().timeZone
                    }
                    isEditing={editTime}
                    setIsEditing={setEditTime}
                    editorComponent={
                      <TimeInput
                        value={timeStart}
                        onChange={(e) => {
                          setTimeStart(e.target.value);
                          updateData("time_start_sending", e.target.value);
                        }}
                        leftSection={<IconClock size={16} />}
                        withSeconds
                        size="sm"
                        radius="md"
                        w="100%"
                        autoFocus
                      />
                    }
                  />
                </Grid.Col>

                {/* 3. LIMITE QUOTIDIENNE */}
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <ProgramCard
                    icon={<IconGauge size={24} />}
                    label={
                      lang.workflows?.program?.step_config?.daily_send_limit ||
                      "Limite quotidienne d'envoi"
                    }
                    valueDisplay={dailyLimit}
                    helpText={lang.campaign?.limit_help}
                    isEditing={editLimit}
                    setIsEditing={setEditLimit}
                    editorComponent={
                      <NumberInput
                        value={dailyLimit}
                        onChange={(val) => updateData("daily_send_limit", val)}
                        min={0}
                        size="sm"
                        radius="md"
                        w="100%"
                        autoFocus
                      />
                    }
                  />
                </Grid.Col>
              </Grid>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>

        <Accordion
          variant="contained"
          bg={"#fff"}
          radius={"xl"}
          //   defaultValue={"list"}
          mt={"md"}
        >
          <Accordion.Item value="list">
            <Accordion.Control>
              <Group>
                <ThemeIcon
                  variant="light"
                  size={"xl"}
                  radius={"xl"}
                  color="red"
                >
                  <IconX />
                </ThemeIcon>
                <Stack gap={0}>
                  <Group>
                    <Text fw={600}>ÉTAPE 3 - Exclusions</Text>
                    <Text c="dimmed" size="sm">
                      facultatif
                    </Text>
                  </Group>
                  <Text c="dimmed">
                    Ces contacts ne recevront pas l’email, même s’ils font
                    partie de l’audience.
                  </Text>
                </Stack>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack>
                <NewsletterBlacklistsExclusion
                  blacklistIds={programData?.blacklist_ids || []}
                  setBlacklistIds={(v) => updateData("blacklist_ids", v)}
                />

                <NewsletterSentCampaignExclusion
                  sentCampaignIds={programData?.sent_campaign_ids || []}
                  setSentCampaignIds={(v) => updateData("sent_campaign_ids", v)}
                  // campaignId={campaignId}
                />
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>

        <Accordion variant="contained" bg={"#fff"} radius={"xl"} mt={"md"}>
          <Accordion.Item value="list">
            <Accordion.Control>
              <Group>
                <ThemeIcon
                  variant="light"
                  size={"xl"}
                  radius={"xl"}
                  color="gray"
                >
                  <IconSettings />
                </ThemeIcon>
                <Stack gap={0}>
                  <Text>Plus d’options</Text>
                </Stack>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <NewsletterAdvancedSettings />
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Box>

      <CampaignSummary />
    </Group>
  );
};

export default StepRecap;
